import { render, staticRenderFns } from "./UserRolesView.vue?vue&type=template&id=3f52d0ca&"
import script from "./UserRolesView.vue?vue&type=script&lang=ts&"
export * from "./UserRolesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports